module.exports = __webpack_public_path__ + "static/cercazone_sudovest2-6f941dad434e06701acc4a500d40f8d0.jpg";